export const ENV_PRESETS: Record<
  string,
  { apiUrl: string; clientAlias: string; label: string; id: string }
> = {
  custom: {
    apiUrl: '',
    clientAlias: 'palmlaneqa',
    label: 'Custom',
    id: 'custom',
  },
  dev: {
    apiUrl: 'https://dev1.incentiviodev.com/incentivio-admin-api',
    clientAlias: 'palmlanedev',
    label: 'Dev',
    id: 'dev',
  },
  uat: {
    apiUrl: 'https://uat-adminapi.incentivio.com/incentivio-admin-api',
    clientAlias: 'pureburger',
    label: 'UAT',
    id: 'uat',
  },
  prod: {
    apiUrl: 'https://adminapi.incentivio.com/incentivio-admin-api',
    clientAlias: 'pureburger',
    label: 'Prod',
    id: 'prod',
  },
};
